import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useUser } from "../context/UserContext";
export const Verify = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { setUser } = useUser();
  // const authToken = Cookies.get("authToken");
  const authToken = localStorage.getItem("authToken");
  const [username, setUsername] = useState("");
  const [team, setTeam] = useState("");

useEffect(() => {
  if (authToken) {
    // Cookies.remove("authToken");
    localStorage.removeItem("authToken")
  }
  const verifyToken = async () => {
    try {
      const data = {
        token: params.token,
      };

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/API/V2/auth/verify/jasso`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        },
      );

      if (response.status === 401) {
        alert("Session Time out");
        // window.location.href = process.env.REACT_APP_JBM_LOGIN_URL;
        return;
      }
      if (response.status === 403) {
        alert("User not registered");
        // window.location.href = process.env.REACT_APP_JBM_LOGIN_URL;
        return;
      }

      const responseData = await response.json();

      if (responseData.error) {
        return;
      }

      if (responseData.code === "C00") {
        localStorage.setItem("authToken", responseData.token);
        localStorage.setItem("jassoVerified", responseData.jasso_verify);
        const email = responseData.email;
        const isPartner = responseData.isPartner;

        if (!isPartner) {
          try {
            const userResponse = await fetch(
              `${process.env.REACT_APP_BACKEND_URL}/API/V2/users/${email}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${responseData.token}`,
                },
              },
            );

            if (userResponse.ok) {
              const userData = await userResponse.json();
              // Cache the full public user record (PUBLIC_USER_FIELDS + computed
              // flags) as returned by the API — no picking/dropping fields here.
              localStorage.setItem("user", JSON.stringify(userData));
              localStorage.setItem("username", userData.email || "");
              setUser({
                username: userData.email || "",
                isPartner: false,
                isPMO: userData.isPMO ?? false,
                name: userData.name ?? "",
                team: userData.team ?? "",
                usertype: userData.usertype ?? "",
                role: userData.role ?? {},
                canApproveLoa: userData.canApproveLoa ?? false,
                loaded: true,
              });
            }
            // Non-OK (e.g. the user has no internal record) falls through —
            // UserContext's own /users/me fallback will pick it up.
          } catch (userError) {
            // Swallow — UserContext's fallback fetch covers this on next load.
          }
        } else {
          // Partners have no record in the internal Users collection, so there's
          // nothing to fetch — hydrate directly from what Jasso already told us.
          const cached = {
            email, isPartner: true, isPMO: false, name: "", team: "",
            usertype: "", role: {}, canApproveLoa: false,
          };
          localStorage.setItem("user", JSON.stringify(cached));
          localStorage.setItem("username", email || "");
          setUser({
            username: email || "",
            isPartner: true,
            isPMO: false,
            name: "",
            team: "",
            usertype: "",
            role: {},
            canApproveLoa: false,
            loaded: true,
          });
        }

        navigate("/Dashboard");

      } else if (responseData.code === "C042") {
        // handle C042
      } else if (responseData.code === "C049") {
        // handle C049
      } else if (responseData.code === "C051") {
        // handle C051
      }
    } catch (error) {
      // console.error(error);
    }
  };

  verifyToken();
}, []);

  // async function setCookie(key, value) {
  //   await Cookies.set(key, value);
  // }
};
